import { render, staticRenderFns } from "./EleccionModalidad.vue?vue&type=template&id=fa3af5ba"
import script from "./EleccionModalidad.vue?vue&type=script&lang=ts"
export * from "./EleccionModalidad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports